import {getUrlPath} from "./get-url-path.ts";

export const getPrivacyPolicyUrl = (): string => {
    return getUrlPath("privacyPolicy");
};
